import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SkuDataService {
  private SKU: any;
  
private httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};
  selectedCategory: any;
  constructor(private http:HttpClient) {}
  get() {
    return JSON.parse(localStorage.getItem('sku'))
  }
  set(sku: any) {
    localStorage.setItem('sku',JSON.stringify(sku))
    this.SKU = sku;
  }
  setSelectedCategory(category: any){
    this.selectedCategory = category;
  }
  
  getSelectedCategory(){
   return this.selectedCategory; 
  }

  geteShopSKU(sku: string) {
     return this.http.get(`${environment.BASE_URL}/skus/${sku}`,this.httpOptions)
  }

  getAdditionalSkus(link:string){
    return this.http.get(link,this.httpOptions)
  }

  addAddons(payload: any, link:string) {
    return this.http.post(`${environment.BASE_URL}` + link,payload,this.httpOptions)
  }

  getSkuById (skuId : String) {
     return this.http.get(`${environment.BASE_URL}/getSku/${skuId}`, this.httpOptions)
  }
  
}
